import axios from "axios";

const URL_CNPJ = "https://receitaws.com.br/v1/cnpj";

const api_cnpj = axios.create({
    baseURL : URL_CNPJ,
});

export default api_cnpj;

